module.exports = __webpack_public_path__ + "static/media/ATV.6e9b5e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/ATV.png
// module id = 3036
// module chunks = 0